import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { AccountGroup } from '@galaxy/account-group';
import { CommonModule } from '@angular/common';
import { ColumnDefinition, CustomCellComponent } from '@vendasta/va-filter2-table';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Activity } from '@vendasta/automata';
import { BusinessInfoCellComponent as SharedBusinessInfoCellComponent } from './business-info-cell/business-info-cell.component';

interface ActivityRow {
  activity: Activity;
  accountGroup?: AccountGroup;
}

@Component({
  selector: 'automata-business-info-cell',
  template: `
    <automata-business-cell *ngIf="!!accountGroup" [accountGroup]="accountGroup"></automata-business-cell>
    <automata-business-cell
      *ngIf="!accountGroup"
      [accountGroupId]="this.element?.activity?.entityId"
    ></automata-business-cell>
  `,
  imports: [CommonModule, TranslateModule, SharedBusinessInfoCellComponent],
})
export class BusinessInfoCellComponent implements OnInit, CustomCellComponent<ActivityRow> {
  @Input() columnDefinition: ColumnDefinition;
  @Input() translateService: TranslateService;
  @Input() element: ActivityRow;
  @Input() eventEmitter: EventEmitter<any>;

  accountGroup: AccountGroup;

  ngOnInit(): void {
    this.accountGroup = this.element?.accountGroup;
  }

  clicked(_e: MouseEvent): void {
    window.open(`businesses/accounts/${this.element.activity.entityId}/details`, '_blank', 'noopener');
  }
}
